import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Benefit: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.09996 3.39865L1.48256 8.20499C1.20063 8.57959 1.21679 9.09975 1.52143 9.45612L11.4531 21.0743C11.8627 21.5535 12.6082 21.5387 12.9985 21.0437L22.5302 8.95478C22.808 8.60253 22.8172 8.10844 22.5527 7.7461L19.3885 3.41048C19.2002 3.15253 18.9001 3 18.5807 3H5.89895C5.58478 3 5.28888 3.14764 5.09996 3.39865Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M5.78259 3L7.69564 9L11.0441 19.8911C11.3336 20.8326 12.6664 20.8326 12.9558 19.8911L16.3043 9L18.2174 3"
        stroke={color}
        strokeWidth="2"
      />
      <rect x="1" y="8" width="21.0435" height="2" fill={color} />
      <path
        d="M7.69568 9L11.1875 4.13263C11.5864 3.57651 12.4136 3.57651 12.8126 4.13263L16.3044 9"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default Benefit;
